export * from './geoops-store';
export type { GeoZone as GeoOpsZone } from './geoops-store';

export type ZoneType = 'impact_zone' | 'evacuation_zone' | 'staging_area' | 'exclusion_zone' | 'custom';
export type ZoneStatus = 'active' | 'planned' | 'resolved';

export const ZONE_TYPE_META: Record<string, { label: string; color: string; mantine: string; icon: string }> = {
  impact_zone:     { label: 'Impact Zone',     color: '#DC2626', mantine: 'red',    icon: 'IconFlame' },
  evacuation_zone: { label: 'Evacuation Zone', color: '#F59E0B', mantine: 'yellow', icon: 'IconArrowsMove' },
  staging_area:    { label: 'Staging Area',    color: '#2563EB', mantine: 'blue',   icon: 'IconFlag' },
  exclusion_zone:  { label: 'Exclusion Zone',  color: '#7C3AED', mantine: 'violet', icon: 'IconShield' },
  custom:          { label: 'Custom',          color: '#6B7280', mantine: 'gray',   icon: 'IconTag' },
};

export const DEFAULT_ZONE_COLORS = {
  impact_zone:     '#DC2626',
  evacuation_zone: '#F59E0B',
  staging_area:    '#2563EB',
  exclusion_zone:  '#7C3AED',
  custom:          '#6B7280',
};
